import { memoizedFetchSiteUserPersonalization } from '@atlassian/jira-personalization-service/src/services/site-user/index.tsx';
import type { Trait } from '@atlassian/jira-personalization-service/src/types.tsx';

export const isNewActiveUser = async (cloudId: string, userId: string, newActiveDays = 14) => {
	const userTraits = await memoizedFetchSiteUserPersonalization({ cloudId, userId });
	return findAndCheckActiveDate(userTraits, newActiveDays);
};

const findAndCheckActiveDate = (traits: Trait[], newActiveDays: number): boolean => {
	const traitName = 'jira_first_active';

	const firstActiveTrait = traits.find((trait) => trait.name === traitName);

	if (firstActiveTrait?.value) {
		const oneWeekActive = new Date(firstActiveTrait?.value.toString());
		oneWeekActive.setDate(oneWeekActive.getDate() + newActiveDays);
		const today = new Date();
		return today <= oneWeekActive;
	}
	return true;
};
